import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import StaffApi from '@/services/apiServiceModules/staffApi.js'
const staffApi = new StaffApi()

export default class StaffDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.STAFF, staffApi, {
			useCache: true,
		})
	}

	setPermissions(companyId, entityId, body) {
		const config = {
			apiServiceMethodName: 'setPermissions'
		}

		const apiMethodPayload = {
			urlParams: {
				companyId,
				entityId
			},
			...body,
		}

		return this.dataTransferWrapMethod(this.moduleName, this.apiModule, config, apiMethodPayload)
	}
}
